import Action from "../actions";

export function orderManagementReducer(state ={
    viewList: {
        orderList: [],
        total: 0,
    },
    ViewDetail: {}
}, action) {
    if (action.type === Action.SET_ORDER_MANAGEMENT) {
        return action.data
    }
    return state;
}